<template>
  <v-card class="review-cart">
    <v-card-title class="review-cart__close pa-0 py-3">
      <v-btn
        text
        icon
        plain
        depressed
        class="ma-0"
        @click="close"
      >
        <v-icon
          medium
        >
          mdi-close
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="review-cart__title pa-0 mb-2">
      Ops... Revise o seu pedido!
    </v-card-text>

    <v-card-text class="review-cart__content pa-0 mb-4">
      Parece que um ou mais produtos sofreram alterações.
    </v-card-text>

    <v-card-actions class="ma-0 pa-0 justify-center">
      <v-btn
        depressed
        dark
        color="#140C22"
        class="review-cart__btn"
        @click="close"
      >
        Voltar para resumo do pedido
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    close: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.review-cart {
  width: 100%;
  text-transform: none;
  border-radius: 7px;
  padding: 0 40px 40px;
  &__title {
    font: 700 20px/27px 'Nunito Sans';
    color: #140C22;
  }
  &__content {
    font: 400 16px/22px 'Nunito Sans';
    color: #140C22;
  }
  &__btn {
    font: 600 14px 'Nunito Sans';
    width: 100%;
    padding: 12px 24px;
    border-radius: 7px;
    text-transform: none;
  }
  &__close {
    position: relative;
    right: -25px;
    display: flex;
    justify-content: end;
  }
}
</style>
